export default class CoachingSession {
    constructor(boards, groups, students, coachingSessionSpaces, title, date, duration, photo, backgroundImage, description, messageType, coachFirstMessage) {
        this.boards = boards;
        this.groups = groups;
        this.students = students;
        
        this.coachingSessionSpaces = coachingSessionSpaces;
        this.title = title;
        this.date = date;
        this.duration = duration;
        this.photo = photo;
        this.backgroundImage = backgroundImage;
        this.description = description;

        this.messageType = messageType;
        this.coachFirstMessage = coachFirstMessage;
     }

     isValid() {
        let result = true;

        if(result) result = this.boards && this.boards.length !== 0 && this.groups && this.groups.length !== 0 && this.coachingSessionSpaces && this.title && this.date && this.duration && this.photo && this.description;

        if (this.messageType === 'BeforeClass' && !this.coachFirstMessage) {
            return false;
        }    
    
        return result;
    }    
}